export enum DocDfeAtorPapel {
  EMITENTE = 'EMITENTE',
  DESTINATARIO = 'DESTINATARIO',
  TRANSPORTADOR = 'TRANSPORTADOR',
  TERCEIROS = 'TERCEIROS',
  OUTROS = 'OUTROS'
}

export enum DocDfeAtorTipoIdentificador {
  CNPJ = 'CNPJ',
  CPF = 'CPF',
  EMAIL = 'EMAIL'
}

export interface DocDfeAtor {
  papel: DocDfeAtorPapel
  tipoIdentificador: DocDfeAtorTipoIdentificador
  identificador: string
  nome?: string
}